export default __webpack_public_path__ + "static/media/matthew.a37bc955.jpg";